import { render, staticRenderFns } from "./MaterialTemplateRegister.vue?vue&type=template&id=452304ba&"
import script from "./MaterialTemplateRegister.vue?vue&type=script&lang=ts&"
export * from "./MaterialTemplateRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports